import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Radio } from 'antd';

import {
    paginacioPerDefecte,
    ordenarAttribut,
    obtenirEstatPerDefecte,
    realitzarCerca,
    obtenirFiltreDesplegable,
    obtenirFiltreIcona,
    obtenirFiltreDesplegableVisible,
    obtenirFiltreCanviarDesplegableVisible,
    seleccionarPaginacio,
    modificarColumnesBooleanesPerTextSiNo
} from '../commons/taulaOrdenacioCerca';

import { textQuanNoHiHaDada } from '../../constants';

const columnaCodi = 'codi';
const columnaNomRol = 'nomRol';
const columnaNom = 'nom';
const columnaCognoms = 'cognoms';
const columnaTelefon = 'telefon';
const columnaEmail = 'email';
const columnaNomComarca = 'nomComarca';
const columnaNomMunicipi = 'nomMunicipi';
const columnaEsActiu = 'esActiu';

// Aquesta parametrització de columnes està relacionada amb el mètode obtenirConfiguracioColumnes()
const columnesAmbFiltres = [columnaCodi, columnaNomRol, columnaNom, columnaCognoms, columnaTelefon, columnaEmail, columnaNomComarca, columnaNomMunicipi, columnaEsActiu];

class UsuariTaula extends Component {

    constructor(props) {
        super(props);
        const { usuaris } = props;
        const usuarisSenseBooleans = modificarColumnesBooleanesPerTextSiNo(usuaris);
        this.state = obtenirEstatPerDefecte(usuarisSenseBooleans, columnesAmbFiltres);
        this.realitzarCercaUsuaris = this.realitzarCercaUsuaris.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.usuaris !== nextProps.usuaris) {
            const { usuaris } = nextProps;
            const usuarisSenseBooleans = modificarColumnesBooleanesPerTextSiNo(usuaris);
            this.setState(() => obtenirEstatPerDefecte(usuarisSenseBooleans, columnesAmbFiltres));
        }
    }

    realitzarCercaUsuaris(item) {
        const { usuaris } = this.props;
        const { searchText } = this.state.filtres[item];
        const usuarisSenseBooleans = modificarColumnesBooleanesPerTextSiNo(usuaris);
        realitzarCerca(item, usuarisSenseBooleans, searchText, columnesAmbFiltres, this.setState.bind(this));
    }

    obtenirConfiguracioColumnaOrdenadaIFiltrada(nom, item, tipus) {
        return {
            title: nom,
            dataIndex: item,
            key: item,
            sorter: (itemA, itemB) => ordenarAttribut(itemA, itemB, item, tipus),
            filterDropdown: obtenirFiltreDesplegable(item, this.state, this.setState.bind(this), this.realitzarCercaUsuaris.bind(this)),
            filterIcon: obtenirFiltreIcona(item, this.state),
            filterDropdownVisible: obtenirFiltreDesplegableVisible(item, this.state),
            onFilterDropdownVisibleChange: (visible) => obtenirFiltreCanviarDesplegableVisible(item, visible, this.setState.bind(this)),
            className: 'usuari-taula-' + item,
            render: text => text || textQuanNoHiHaDada
        };
    }

    obtenirConfiguracioColumnes() {
        return [
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Codi', columnaCodi),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Perfil', columnaNomRol),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Nom', columnaNom),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Cognoms', columnaCognoms),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Telèfon', columnaTelefon),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Correu electrònic', columnaEmail),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Comarca', columnaNomComarca),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Municipi', columnaNomMunicipi),
            this.obtenirConfiguracioColumnaOrdenadaIFiltrada('Actiu', columnaEsActiu)
        ];
    }

    render() {
        const { onClickUsuari } = this.props;
        const { paginacio } = this.state;
        const mostrarSelectorPaginacio = this.state.data.length > 0 ? 'block' : 'none';

        return (
            <div className='usuari-taula'>
                <Table
                    dataSource={this.state.data}
                    columns={this.obtenirConfiguracioColumnes()}
                    pagination={{ pageSize: paginacio, position: 'bottom'}}
                    bordered
                    scroll={{y:644 }}
                    size='middle'
                    onRow={(record) => ({
                        onClick: () => { onClickUsuari(parseInt(record.id, 0)); }
                    })}
                    rowKey={record => record.id}
                />
                <Radio.Group
                    className='usuari-taula-selector-paginacio'
                    size='small'
                    onChange={(event) => seleccionarPaginacio(event.target.value, this.setState.bind(this))}
                    style={{ display: mostrarSelectorPaginacio }}
                    value={paginacio}>
                    <Radio.Button value={paginacioPerDefecte}>{paginacioPerDefecte}</Radio.Button>
                    <Radio.Button value={40}>40</Radio.Button>
                    <Radio.Button value={60}>60</Radio.Button>
                    <Radio.Button value={100}>100</Radio.Button>
                </Radio.Group>
            </div>
        );
    }
}

UsuariTaula.propTypes = {
    onClickUsuari: PropTypes.func,
    usuaris: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            nom: PropTypes.string,
            cognoms: PropTypes.string,
            codi: PropTypes.string,
            esActiu: PropTypes.bool,
            mobil: PropTypes.string,
            email: PropTypes.string,
            nomRol: PropTypes.string,
            nomMunicipi: PropTypes.string,
            nomComarca: PropTypes.string
        })
    )
};

export default UsuariTaula;



// WEBPACK FOOTER //
// ./src/components/usuari/usuariTaula.js